import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from '../routes/AppRouter';
import store from '../store/store';
import { whichEnvURL } from '../helpers/utils';

const App = () => {
	const env = whichEnvURL(true);
	const basePath = env !== 'live' ? '/pilu' : '/';

	return (
		<Provider store={store}>
			<HelmetProvider>
				<BrowserRouter basename={basePath === '/' ? undefined : basePath}>
					<AppRouter />
				</BrowserRouter>
			</HelmetProvider>
		</Provider>
	);
};
// Create root
const root = createRoot(document.getElementById('root'));

// Render root
root.render(<App />);
